export default "__VITE_ASSET__NjmQRNEu__"